import {
  ArrowRight,
  BriefcaseBusiness,
  CircleDollarSign,
  Coins,
  ShieldCheck,
  Sparkles,
} from "lucide-react";

import { BrokerArtwork } from "@web/features/terminal/BrokerArtwork";

const destinations = [
  {
    href: "/app/trade#buy-land",
    icon: Coins,
    title: "LAND trading",
    text: "Swap ETH for LAND directly through the canonical Uniswap v4 pool.",
  },
  {
    href: "/app/trade#buy-broker",
    icon: CircleDollarSign,
    title: "Broker market",
    text: "Use LAND to buy the next Broker or choose an exact Broker ID.",
  },
  {
    href: "/app/portfolio",
    icon: BriefcaseBusiness,
    title: "Portfolio",
    text: "Choose an earning tier and pay the displayed LAND activation cost.",
  },
  {
    href: "/app/rewards",
    icon: Sparkles,
    title: "Rewards",
    text: "See the RWA tokens inside your Broker and its estimated next-round share.",
  },
];

export function LandingPage() {
  return (
    <>
      <section className="landing-hero">
        <div className="landing-copy">
          <span className="eyebrow">BROKER NFTS · RWA EMISSIONS · ETH CHAIN</span>
          <h1>Own the Broker. Earn the assets.</h1>
          <p>
            LAND powers Broker trading and earning tiers. RWA emissions arrive
            directly inside every working Broker.
          </p>
          <div className="landing-actions">
            <a className="primary-action" href="/app/trade">
              TRADE <ArrowRight size={16} />
            </a>
            <a className="landing-secondary" href="/app/rewards">
              VIEW REWARDS
            </a>
          </div>
          <div className="landing-proof" aria-label="Protocol properties">
            <span>
              <ShieldCheck size={15} /> Rewards stay with the Broker
            </span>
            <span>4,444 Brokers</span>
            <span>4 RWA assets</span>
          </div>
        </div>

        <div className="landing-art" aria-label="Stonkland Broker example">
          <BrokerArtwork tokenId={1} />
          <div className="art-caption">
            <span>Broker #0001</span>
            <strong>THE REWARDS MOVE WITH IT</strong>
          </div>
        </div>
      </section>

      <section className="landing-section" id="how-it-works">
        <div className="landing-section-heading">
          <span className="section-kicker">Explore Stonkland</span>
          <h2>Everything in one place.</h2>
          <p>
            Trade, manage your Brokers and understand rewards without following
            a forced onboarding sequence.
          </p>
        </div>
        <div className="action-grid">
          {destinations.map(({ href, icon: Icon, title, text }) => (
            <a className="action-card" href={href} key={title}>
              <div>
                <Icon size={20} />
              </div>
              <h3>{title}</h3>
              <p>{text}</p>
              <strong>
                OPEN <ArrowRight size={14} />
              </strong>
            </a>
          ))}
        </div>
      </section>

      <section className="landing-emissions">
        <div>
          <span className="section-kicker">Where emissions come from</span>
          <h2>Protocol fees become RWA emissions.</h2>
          <p>
            Trading and loan fees fill the reward pot. When it is ready,
            anyone can start a round that buys RWA tokens and sends them to
            every working Broker.
          </p>
        </div>
        <ul className="emission-flow">
          <li>
            <CircleDollarSign size={18} />
            <div>
              <strong>Fees fill the pot</strong>
              <small>Broker trades and loans create ETH fees.</small>
            </div>
          </li>
          <li>
            <Coins size={18} />
            <div>
              <strong>The pot buys RWA tokens</strong>
              <small>NVDA, TSLA, AAPL and GOOGL.</small>
            </div>
          </li>
          <li>
            <BriefcaseBusiness size={18} />
            <div>
              <strong>Working Brokers receive them</strong>
              <small>Higher earning tiers receive a larger share.</small>
            </div>
          </li>
        </ul>
      </section>
    </>
  );
}
